export default __webpack_public_path__ + "static/media/restaurant.f6f10ced.png";